<template>
    <div class="overview mainBody">
        <div class="charts">
            <div class="input_group" v-if="groupList.item1.isShow">
                        <label v-if="groupList.item1.selectOrinput" class="input_label" for="select">{{groupList.item1.lable}}</label>
                        <el-select v-if="groupList.item1.selectOrinput" id="select" class="inputInner" v-model="groupList.item1.selectValue" @change='getEQDetailById' placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item1.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item1.selectOrinput" class="input_label" for="input">{{groupList.item1.lable}}</label>
                        <el-input v-if="!groupList.item1.selectOrinput" id="input" class="inputInner" v-model="groupList.item1.inputValue" placeholder="请输入内容"></el-input>
                    </div>
            <div id="main">
                <div class="main_head">
                    <h1>船舶概览</h1>
                </div>
                <div class="main_body">
                    <div class="body_img">
                        <img  src="../../../../assets/temp/72775fefa9708442c886736b4e1e0fd.png" alt="">
                    </div>
                    <div class="inner_input">
                        <div class="itemBox" ><label for="input">船长：</label><input id="input" @change="inputChange" v-model="groupList.item3.inputValue" class="item" type="text"></div>
                        <div class="itemBox" ><label for="input">船宽：</label><input id="input" @change="inputChange"  v-model="groupList.item4.inputValue" class="item" type="text"></div>
                        <div class="itemBox" ><label for="input">船龄：</label><input id="input" @change="inputChange"  v-model="groupList.item5.inputValue" class="item" type="text"></div>
                        <div class="itemBox" ><label for="input">船舶人数：</label><input id="input" @change="inputChange"  v-model="groupList.item6.inputValue" class="item" type="text"></div>
                        <div class="itemBox" ><label for="input">船舶负责人：</label><input id="input" @change="inputChange"  v-model="groupList.item7.inputValue" class="item" type="text"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="charts">
            <div class="input_group" v-if="groupList.item2.isShow">
                        <label v-if="groupList.item2.selectOrinput" class="input_label" for="select">{{groupList.item2.lable}}</label>
                        <el-select v-if="groupList.item2.selectOrinput" id="select" @change='selectChange' class="inputInner" v-model="groupList.item2.selectValue" :placeholder="groupList.item2.placeHolder">
                            <el-option
                            v-for="item in groupList.item2.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item2.selectOrinput" class="input_label" for="input">{{groupList.item2.lable}}</label>
                        <el-input v-if="!groupList.item2.selectOrinput" id="input" class="inputInner" v-model="groupList.item2.inputValue" placeholder="请输入内容"></el-input>
                    </div>
                    <div id="main">
                        <div class="main_head">
                            <h1>船舶事件</h1>
                        </div>
                        <div class="main_body">
                            <div id="main2">
                
                             </div>
                        </div>
                    </div>
            
        </div>
        
    </div>
</template>

<script>
import * as echarts from 'echarts';
import API from '@/api/material';
import moment from 'moment';
export default {
    
    name:'overview',
    data(){
        return{
            groupList:{
                item1:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'选择船舶',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    selectValue:null,
                    inputValue:null,
                },
                item2:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'筛选',
                    selectOptions:[],
                    placeHolder:'一个月以内',
                    selectValue:null,
                    inputValue:null,
                },
                item3:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'筛选',
                    selectOptions:[],
                    placeHolder:'一个月以内',
                    selectValue:null,
                    inputValue:null,
                },
                item4:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'筛选',
                    selectOptions:[],
                    placeHolder:'一个月以内',
                    selectValue:null,
                    inputValue:null,
                },
                item5:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'筛选',
                    selectOptions:[],
                    placeHolder:'一个月以内',
                    selectValue:null,
                    inputValue:null,
                },
                item6:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'筛选',
                    selectOptions:[],
                    placeHolder:'一个月以内',
                    selectValue:null,
                    inputValue:null,
                },
                item7:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'筛选',
                    selectOptions:[],
                    placeHolder:'一个月以内',
                    selectValue:null,
                    inputValue:null,
                },
            },
            domChar1:'',
            domChar2:'',
            AllClass:this.$store.state.AllClass,
            eventModuleId:2,
            Allsub:'',
            TypeObj:'',
            datasetSource:[[]],
            datasetSource2:[],
        }
    },
    methods:{
        selectChange(){
            this.getEQDetailById()
        },
        amend(){
            //action=update&eventmoduleid=1&eventtypeid=1&detail=22222&id=3

            let param = {
                    action:'update',
                    boat_id:this.groupList.item1.inputValue,
                    boat_name:this.groupList.item1.inputValue,
                    age:this.groupList.item5.inputValue,
                    personCount:this.groupList.item6.inputValue,
                    manager:this.groupList.item7.inputValue,
            }
            return new Promise((resolve,reject)=>{
                API.getEQDetail(param).then((res)=>{
                this.groupList.item2.value = '';
                    resolve(res)
                }).catch((err)=>{
                    console.log(err);
                    resolve(0)
                })
            })
            
        },
        inputChange(){
            this.amend().then((message)=>{
                        if(message != 0){
                            this.$message({
                            message: '修改成功',
                            type: 'success'
                            });
                        }else{
                            this.$message({
                            message: '修改失败，请稍后再试',
                            type: 'error'
                            });
                        }
                    })
        },
        formatSignalList(list){
            let tmpList = [];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].boat_id,
                    label:list[i].boat_id,
                })
            }
            return tmpList
        },
        getAll(){
            API.getBoatDetail({action:'getallin'}).then((res)=>{
                this.groupList.item1.selectOptions =this.formatSignalList(res.message.obj);
                this.groupList.item1.selectValue=this.groupList.item1.inputValue =res.message.obj[0].boat_id;
                this.getEQDetailById()
            }).catch((err)=>{
                console.log(err);
            });
            let param = {
                    action:"getall",
                    eventmodule_id:this.eventModuleId
                };
            let param2 ={
                    action:"getall",
                    eventmodule_id:this.eventModuleId
                };
            API.getModuleManagement(param2).then((res)=>{
                this.Allsub =res.message.obj;
            }).catch(err=>{
                console.log(err);
            })
            API.getModuleEvents(param).then((res)=>{
                this.TypeObj =res.message.obj;
            }).then(()=>{
                this.formatChart2Data(this.TypeObj,this.Allsub);
            }).then(()=>{
                this.getCharts2();
            }).catch(err=>{
                console.log(err);
            })
            
        },
        formatChart2Data(TypeObj,Allsub){
            //获取事件类型
            //获取各类型子项
            //根据事件类型创建数组对象
            let data = [];
            Object.values(TypeObj).forEach((item,idx)=>{
                    data.push({
                                value:item.id,
                                sumValue:0,
                                label:item.detail,
                                name:item.eventName,
                                eventtype_id:item.id
                                })
            });
            //eventtypeId筛分数据对象，对应对象的value+1
            Object.values(data).forEach((itemF,idx)=>{
                Object.values(Allsub).forEach((itemS,idx)=>{
                       if(itemF.eventtype_id == itemS.eventtype_id) {
                            itemF.sumValue += 1;
                        };
             
                });
            });
            this.datasetSource2 =  this.groupList.item2.selectOptions =  data;
        },
        fullInput(list){
            this.groupList.item3.inputValue = list.age;
            this.groupList.item4.inputValue = list.personCount;
            this.groupList.item5.inputValue = list.age;
            this.groupList.item6.inputValue = list.personCount;
            this.groupList.item7.inputValue = list.manager;
        },
        getEQDetailById(){
            let param = {
                action:"get",
                boat_id:this.groupList.item1.selectValue
            }
            API.getEQDetail(param).then((res)=>{
                this.fullInput(res.message.obj);
            }).catch(err=>{
                console.log(err);
            })
        },
        getCharts2(){
            let myChart = echarts.getInstanceByDom(document.getElementById('main2'));
            if(!myChart){
                myChart = echarts.init(document.getElementById('main2'))
            }  
            var option;

            option = {
            title: {
                text: '',
                subtext: '',
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'vertical',
                left: 'right',
                top:'center'
            },
            series: [
                {
                name: '质量事件',
                type: 'pie',
                radius: '50%',
                legendHoverLink: true,
                labelLine:{
                    show:false
                },
                data:this.datasetSource2,
                emphasis: {
                    itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },
                    
                }
                }
            ]
            };

            option && myChart.setOption(option);
        }
       

 
    },
    created(){
        
    },
    mounted(){
        this.$nextTick(()=>{
            this.getAll();
            this.getCharts2();
        })
    },
}
</script>

<style scoped>
#main2{
    margin-top: 0;
    height: 75%;
    width: 100%;
    background-color: var(--subject--input2);
    border-radius: var(--border--radius);
}


.item{
    margin-top: 5%;
    border: none;
    width: 60%;
    background-color: transparent;
    color: var(--subject--title);
    font-size: var(--login--text);
}
.item:focus{
    box-shadow: 1px 1px 5px var(--subject--boxShadow);
    color: var(--subject--title);
    background:none;  
	outline:none;  
	border:0px;
}
.itemBox label{
    font-size: var(--login--text);
    color: var(--subject--title);
}
.itemBox:first-child{
    margin-top: 50%;
}
.itemBox:nth-child(4) .item{
    width: 47%;
}
.itemBox:nth-child(5) .item{
    width: 40%;
}
.itemBox:first-child{
    margin-top: 50%;
}
.inner_input{
    height: 90%;
    width: 40%;
    display: flex;
    flex-direction: column;
    margin-left: 5%;
}
.body_img{
    height: 100%;
    width: 60%;
    display: flex;
    justify-content: center;
}
.body_img img{
    border-radius: var(--border--radius);
    width: 80%;
    height: 50%;
    margin-top: 25%;
    /* z-index: 999; */
}


.overview{
    width: 100%;
    height: 90%;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.charts{
    height: 100%;
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.input_group{
    height: 20%;
    width: 100%;
}
</style>>


